import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatBadgeModule} from '@angular/material/badge';

import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TagModule} from '@app/tag/tag.module';
import {NgScrollbarModule} from 'ngx-scrollbar';
import {UploadButtonComponent} from './upload-button/upload-button.component';
import {UploadDetailDialogComponent} from './upload-detail-dialog/upload-detail-dialog.component';
import {UploadDialogComponent} from './upload-dialog/upload-dialog.component';
import {UploadDropComponent} from './upload-drop/upload-drop.component';
import {UploadService} from './upload.service';

@NgModule({
    imports: [
        CommonModule,
        MatListModule,
        MatProgressBarModule,
        MatDialogModule,
        MatTableModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatSnackBarModule,
        NgScrollbarModule,
        MatInputModule,
        ReactiveFormsModule,
        TagModule,
        MatChipsModule,
        MatCheckboxModule,
        MatBadgeModule,
        UploadDialogComponent,
        UploadDropComponent,
        UploadButtonComponent,
        UploadDetailDialogComponent,
    ],
    exports: [UploadDialogComponent, UploadDropComponent, UploadButtonComponent],
    providers: [UploadService],
})
export class UploadModule {}
